import { ClosingCTA } from '@/components/home/ClosingCTA';
import { Community } from '@/components/home/Community';
import { ContactLocation } from '@/components/home/ContactLocation';
import { FaqSection } from '@/components/home/FaqSection';
import { FeaturedTeachers } from '@/components/home/FeaturedTeachers';
import { FindALesson } from '@/components/home/FindALesson';
import { Hero } from '@/components/home/Hero';
import { HowItWorks } from '@/components/home/HowItWorks';
import { PracticeRoomsSection } from '@/components/home/PracticeRoomsSection';
import { StudentStories } from '@/components/home/StudentStories';
import { Subjects } from '@/components/home/Subjects';
import { PageShell } from '@/components/layout/PageShell';
import { usePageTitle } from '@/lib/usePageTitle';

export default function HomePage(): React.JSX.Element {
  usePageTitle('MusicVille Academy — music lessons in Baku');

  return (
    <PageShell>
      <div className="mv-home">
        <Hero />
        <FindALesson />
        <Subjects />
        <HowItWorks />
        <FeaturedTeachers />
        <PracticeRoomsSection />
        <Community />
        <StudentStories />
        <ClosingCTA />
        <FaqSection limit={6} />
        <ContactLocation />
      </div>
    </PageShell>
  );
}
